const initialState = '';

export default function freightLabelReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_FREIGHT_LABEL':
            return action.payload;
        default:
            return state;
    }
}
